<template>
  <div class="block docx-view-block">
    <div>
      <slot :tableId="tableId"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "view-block",
  props: {
    tableId: {
      type: String,
      default:'',
    },
  }
};
</script>